import {
    Box,
    Button,
    ButtonGroup,
    ClickAwayListener,
    Grow,
    IconButton,
    MenuList,
    Paper,
    Popper,
    TextField,
    useTheme
} from "@mui/material";
import { CalendarToday, Close } from '@mui/icons-material';
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import React, { FC, useRef, useState } from "react";

import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/uk";

import { calendar_outlined } from "../../../assets/icons";

interface Props {
    value: Dayjs | null;
    setValue: (newValue: Dayjs | null) => void;
}

const ButtonDatePicker: FC<Props> = ({ value, setValue }) => {
    const { palette } = useTheme();

    const [open, setOpen] = useState(false);
    const anchorRef = useRef<any>(null);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: Event) => {
        if (
            anchorRef.current &&
            anchorRef.current.contains(event.target as HTMLElement)
        ) {
            return;
        }

        setOpen(false);
    };
    return (
        <>
            <IconButton
                ref={anchorRef}
                onClick={handleToggle}
                size="small"
                disableRipple
                sx={{
                    p: { xs: "8px", md: "8px 16px" },
                    borderRadius: "4px",
                    background: palette.primary.dark,
                    mr: { xs: "8px", md: "12px" }
                }}
            >
                <Box sx={{ width: "16px", height: "16px" }}>
                    <img
                        loading="eager" src={calendar_outlined} alt="calendar_outlined" style={{ width: "inherit", height: "inherit" }} />
                </Box>
            </IconButton>
            <Popper
                sx={{ zIndex: 1 }}
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === 'bottom' ? 'center top' : 'center bottom',
                        }}
                    >
                        <Paper
                            sx={{
                                borderRadius: "0px",
                                border: `1px solid ${palette.text.secondary}`,
                                "& .MuiPickersDay-root.Mui-selected": {
                                    border: `1px solid ${palette.primary.main}`,
                                    borderRadius: "50%",
                                    color: palette.primary.main
                                }
                            }}
                        >
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList id="split-button-menu" autoFocusItem sx={{ p: 0 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={"uk"}>
                                        <StaticDatePicker
                                            displayStaticWrapperAs="desktop"
                                            value={value}

                                            onChange={(newValue) => {
                                                setValue(newValue);
                                                handleToggle()
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </LocalizationProvider>
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>

                    </Grow>
                )}
            </Popper>
        </>
    );
}

export default ButtonDatePicker;
